export const features = [
  {
    id: 1,
    title: 'Website Development',
    // icon: 'assets/website.png',
    icon: 'assets/responsive.png',
    detail:
      'I will handel everything(front-end) from to website development process until it is time to make your project live.',
  },
  {
    id: 2,
    title: 'Responsive Design',
    icon: 'assets/responsive.png',
    detail:
      'I will handel everything for websites that allows the layout to adapt to the size of the users device or screen.',
  },
  {
    id: 3,
    title: 'SEO Optimisation',
    // icon: 'assets/seo.png',
    icon: 'assets/responsive.png',
    detail:
      'Your Website ranking maters.I will help you get to the top of the ranks and stay there!',
  },
  {
    id: 4,
    title: 'UX Consulting',
    // icon: 'assets/ux.png',
    icon: 'assets/responsive.png',
    detail:
      'A UX consulting is responsible for many of the same tasks as a UX designer.This can include web applications, mobile apps, websites, software, and other digital products. ',
  },
  {
    id: 5,
    title: 'Hosting',
    // icon: 'assets/hosting.png',
    icon: 'assets/responsive.png',
    detail:
      'Hosting refers to the practice of making a website or application available on the Internet. Websites and applications are hosted on servers, which makes your website live in the internet',
  },
  {
    id: 6,
    title: 'Basic Website Design',
    // icon: 'assets/hosting.png',
    icon: 'assets/responsive.png',
    detail:
      'I can design of basic user interface of website using figma and photoshop',
  },
]
